import { logError } from '../log/logger';
import loadScript from './load_script';

const getEid = async () => {
  await loadScript(process.env.URL_ID5);
  // eslint-disable-next-line no-undef
  const id5Instance = ID5.init({ partnerId: 1141 });
  id5Instance.onAvailable((status) => {
    // eslint-disable-next-line no-underscore-dangle
    if (!status._userIdAvailable) {
      logError('[AdsManager] Problem loading ID5 , probably need more time');
    } else {
      const EID = status.getUserIdAsEid();
      if (EID.uids[0]?.id === undefined) {
        logError(
          '[AdsManager] Problem loading ID5 , ID5 object is ready but no time to generate ID, need more time',
        );
      }
      // eslint-disable-next-line no-undef
      window.localStorage.setItem('ID5SYNC', JSON.stringify(EID));
    }
  });
};

export default getEid;
